module.exports = __webpack_public_path__ + "img/salty-0.164bd38b.webp";